{
"REGISTER-FUEL--FUELING-LABEL":"Refueling",  
"REGISTER-FUEL--REFUELING":"Enter the refueling details",  
"REGISTER-FUEL--VEHICLE":"Vehicle",
"REGISTER-FUEL--SELECT":"Select",
"REGISTER-FUEL--DRIVER":"Driver",
"REGISTER-FUEL--LOCATION":"Refueling location",
"REGISTER-FUEL--SUPPLIER":"Supplier",
"REGISTER-FUEL--INVOICE":"Invoice number",
"REGISTER-FUEL--AMOUNT":"Amount (R$)",
"REGISTER-FUEL--LITERS":"Liters Fueled",
"REGISTER-FUEL--TYPE":"Fuel Type",
"REGISTER-FUEL--ODOMETER":"Odometer",
"REGISTER-FUEL--HOURMETER":"Hourmeter",
"REGISTER-FUEL--NOTE":"Note (optional)",
"REGISTER-FUEL--ONLY-RECEIPT":"Receipt",
"REGISTER-FUEL--RECEIPT":"Select a receipt",
"REGISTER-FUEL--PHOTO":"Take Photo of Receipt",
"REGISTER-FUEL--SUBMIT":"Submit",

  "REGISTER-FUEL--REGULAR-GASOLINE": "Regular Gasoline",
  "REGISTER-FUEL--ADDITIVE-GASOLINE": "Additive Gasoline",
  "REGISTER-FUEL--PREMIUM-GASOLINE": "Premium Gasoline",
  "REGISTER-FUEL--REGULAR-DIESEL": "Regular Diesel",
  "REGISTER-FUEL--DIESEL-S10": "Diesel S-10",
  "REGISTER-FUEL--ADDITIVE-DIESEL": "Additive Diesel",
  "REGISTER-FUEL--PREMIUM-DIESEL": "Premium Diesel",
  "REGISTER-FUEL--REGULAR-ETHANOL": "Regular Ethanol",
  "REGISTER-FUEL--ADDITIVE-ETHANOL": "Additive Ethanol",
  "REGISTER-FUEL--ALCOHOL": "Alcohol",
  "REGISTER-FUEL--CNG": "CNG",
  "REGISTER-FUEL--ARLA": "ARLA",
  "REGISTER-FUEL--FETCHING-DATA": "Fetching data ...",
  "REGISTER-FUEL--FETCH-DATA-FAILED": "Could not fetch data!",
  "REGISTER-FUEL--FETCHING-ADDRESS": "Fetching address ...",
  "REGISTER-FUEL--LOCATION-INACCURATE": "The location may be inaccurate...",
  "REGISTER-FUEL--INVALID-FIELDS": "Invalid fields!",
  "REGISTER-FUEL--ODOMETER-OR-HOURMETER-REQUIRED": "Please enter at least the odometer or hourmeter!",
  "REGISTER-FUEL--SAVING": "Saving ...",
  "REGISTER-FUEL--TRY-AGAIN-LATER": "Try again later...",
  "REGISTER-FUEL--FUEL-REGISTERED": "Fuel registered!"  
}
